import { render, staticRenderFns } from "./exam-edit.vue?vue&type=template&id=0ebc5de0"
import script from "./exam-edit.vue?vue&type=script&lang=js"
export * from "./exam-edit.vue?vue&type=script&lang=js"
import style0 from "./exam-edit.vue?vue&type=style&index=0&id=0ebc5de0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports